// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddSup_importCsvCard__3yEzk","addSupplierBtnContainer":"AddSup_addSupplierBtnContainer__eEb1g"};